module.exports = __webpack_public_path__ + "img/enon-logo.dfd43e4e.svg";